class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('#predictive-search');
        this.featuredProducts = this.querySelector('.search-drawer-featured-products');
        this.featuredTerms = this.querySelectorAll('.search-drawer-featured-search-terms ul li')

        if (this.getQuery().length) {
            this.open();
            this.getSearchResults(this.getQuery());
        }

        this.input.addEventListener('input', this.debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));

        this.featuredTerms.forEach(term => {
            term.addEventListener('click', (e) => {
                const termValue = term.innerText;
                this.input.value = termValue;
                this.open();
                this.getSearchResults(termValue);
            })
        });
    }

    getQuery(){
        return this.input.value.trim();
    }

    onChange() {
        const searchTerm = this.getQuery();

        if (!searchTerm.length) {
            this.close();
            return;
        }

        this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
        fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=9&resources[options][fields]=title,product_type,variants.title,body,tag&section_id=predictive-search`)
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                }

                return response.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
                this.predictiveSearchResults.innerHTML = resultsMarkup;
                this.open();
            })
            .catch((error) => {
                this.close();
                throw error;
            });
    }

    open() {
        this.predictiveSearchResults.style.display = 'block';
        this.featuredProducts.style.display = 'none';
    }

    close() {
        this.predictiveSearchResults.style.display = 'none';
        this.featuredProducts.style.display = 'block';
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}

customElements.define('predictive-search', PredictiveSearch);

class searchDrawer {
    constructor(){
        this.sail = document.querySelector(".search-drawer-sail");
        this.searchDrawer = document.querySelector(".search-drawer__container");
        this.openSearchDrawer = document.querySelector("[data-predictive-search-open]");
        this.closeBtn = document.querySelector(".search-drawer--close-btn");

        this.input = document.querySelector('predictive-search input[type="search"]');
        this.featuredProducts = document.querySelectorAll('.search-drawer-featured-products > ul > li');
        
        const tlSearchDrawer = gsap.timeline({
            ease: "power3.inOut",
            paused: true,
            reversed: true
        })

        this.tl = tlSearchDrawer;
        
        this.createTimeline();
        this.eventListeners();
    }

    createTimeline(){
        this.tl.fromTo(this.sail, {
            display: "none",
            ease: "power3.inOut",
            autoAlpha: 0,
        },
        {
            duration: 0.8,
            display: "block",
            autoAlpha: 1,
        }, 0)
        .fromTo(this.searchDrawer, {
            display: 'none',
            ease: "power4.inOut",
            yPercent: 200
        },{
            duration: 0.8,
            delay: 0.1,
            display: "block",
            yPercent: 0,
        }, 0.1)
        .from(this.input, {
            width: 0,
            duration: 1.2,
            ease: "power3.inOut",
            immediateRender:false,
            delay: 0.3,
        }, 0.15)
        .from(this.closeBtn, {
            duration: 1.2,
            rotation: 360,
        }, 0.02)
        .from(this.featuredProducts, {
            ease: "power4.inOut",
            xPercent: 200,
            stagger: 0.09,
            duration: 1.2,
        }, 0.24)
    }
    
    toggle(){
        this.tl.reversed() ? this.tl.play() : this.tl.reverse();
        document.body.classList.toggle("overflow-h");
        window.lenis.stop() ? window.lenis.start() : window.lenis.stop();
    }

    open(){
        this.tl.play();
        document.body.classList.add("overflow-h");
        window.lenis.stop();

    }

    close(){
        this.tl.reverse();
        document.body.classList.remove("overflow-h");
        window.lenis.start();
    }

    eventListeners(){
        this.openSearchDrawer.addEventListener("click", (e) => {
            e.preventDefault();
            this.toggle();
            
        })
        
        this.sail.addEventListener("click", (e) => {
            this.close();
        })

        this.closeBtn.addEventListener("click", (e) => {
            this.close();
        })
        
        // Open when hit the letter S (keyboard)
        document.addEventListener('keydown', (e) => {
            if (e.keyCode === 83 && document.activeElement.tagName != 'INPUT') {
                this.open();
            }
            
        });
        
        // close when hit escape
        document.addEventListener('keydown', (e) => {
            if (e.keyCode === 27) {
                this.close();
            }
        });
    }
}

window.searchDrawer = new searchDrawer();
